import { Component } from 'react';

// Red de seguridad: si un componente lanza un error durante el render, en lugar de
// dejar la pantalla en blanco (comportamiento por defecto de React), mostramos un
// mensaje claro con un botón para recargar. Así el equipo nunca ve una página vacía
// sin saber qué hacer.

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hayError: false };
  }

  static getDerivedStateFromError() {
    return { hayError: true };
  }

  componentDidCatch(error, info) {
    // Dejar el error en la consola para diagnóstico (no se muestra al usuario).
    console.error('Error capturado por ErrorBoundary:', error, info);
  }

  render() {
    if (this.state.hayError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          fontFamily: 'Montserrat, system-ui, sans-serif',
          background: '#f8fafc'
        }}>
          <div style={{
            maxWidth: '420px',
            width: '100%',
            background: 'white',
            borderRadius: '16px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
            padding: '32px',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>⚠️</div>
            <h1 style={{ fontSize: '20px', fontWeight: 700, color: '#1e293b', margin: '0 0 8px' }}>
              Ocurrió un problema al mostrar esta página
            </h1>
            <p style={{ fontSize: '14px', color: '#64748b', margin: '0 0 24px', lineHeight: 1.5 }}>
              No te preocupes, tus datos están a salvo. Vuelve a cargar la página para continuar.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: 'linear-gradient(to right, #0ea5e9, #2563eb)',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                padding: '12px 24px',
                fontSize: '15px',
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              Recargar la página
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
